<div class="process-selection">
    <app-centered-scrollable-content>

        <div class="grid">
          <ng-container *ngFor="let entry of processSelectionConfiguration?.selectOptions">
            <div class="column">
              <div class="center">
                <app-tapable-terminal-card>
                  <app-icon-tile [iconScale]="2" [title]="getTitle(entry)" [iconCSS]="entry.titleIconCss" (click)="select(entry)">
                  </app-icon-tile>
                </app-tapable-terminal-card>
              </div>
              <p class="description" *ngIf="entry.descriptionDictionaryKey != null">
                <sc-dictionary-label [dictionaryKey]="entry.descriptionDictionaryKey"></sc-dictionary-label>
              </p>
            </div>
          </ng-container>
        </div>
    </app-centered-scrollable-content>
</div>
